import { Dynamo, MedicalDataTypes, MedicalProfileFiles, SearchTypes } from '.';

export type TableChangeActions = 'create' | 'update' | 'delete';

export type Table = 'resourceRecords' | 'medicalProfileFileArtifacts' | 'careTeamMembers' | 'notes';

export type TableCreateEventMap = {
    resourceRecords: Dynamo.ResourceRecord;
    medicalProfileFileArtifacts: Dynamo.MedicalProfileFileArtifact;
    careTeamMembers: SearchTypes.CareTeamMemberWithContactDetails;
    notes: Dynamo.Note;
};

export type TableUpdateEventMap = {
    resourceRecords: Dynamo.ResourceRecord;
    medicalProfileFileArtifacts: Dynamo.MedicalProfileFileArtifact;
    careTeamMembers: SearchTypes.CareTeamMemberWithContactDetails;
    notes: Dynamo.Note;
};

export type TableDeleteEventMap = {
    resourceRecords: {
        resourceId: string;
        medicalProfileId: string;
        resourceCategory: MedicalDataTypes.PrimaryRecordResourceCategory;
    };
    medicalProfileFileArtifacts: {
        medicalProfileFileArtifactId: string;
        medicalProfileFileId: string;
        medicalProfileId: string;
        artifactType: MedicalProfileFiles.MedicalProfileFileArtifact['artifactType'];
    };
    careTeamMembers: {
        careTeamMemberId: string;
        medicalProfileId: string;
    };
    notes: {
        noteId: string;
        createUserId: string;
        medicalProfileId?: string;
    };
};

export type TableChangeCreateEvent<TTable extends Table> = {
    action: 'create';
    table: TTable;
    record: TableCreateEventMap[TTable];
    skipIfAlreadyExists?: boolean;
};

export type TableChangeUpdateEvent<TTable extends Table> = {
    action: 'update';
    table: TTable;
    record: TableUpdateEventMap[TTable];
};

export type TableChangeDeleteEvent<TTable extends Table> = {
    action: 'delete';
    table: TTable;
    recordKey: TableDeleteEventMap[TTable];
};

export type TableChangeEvent<TTable extends Table> =
    | TableChangeCreateEvent<TTable>
    | TableChangeUpdateEvent<TTable>
    | TableChangeDeleteEvent<TTable>;
